var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradient1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 421,
    viewBox: "0 0 960 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_37_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 936,
    height: 397,
    rx: 12,
    fill: "url(#paint0_linear_37_2)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_37_2",
    x: 0.735763,
    y: 0.735763,
    width: 958.528,
    height: 419.528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.63212,
    result: "effect1_foregroundBlur_37_2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_2",
    x1: 12,
    y1: 36.8125,
    x2: 972.371,
    y2: 207.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#E2D8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FFD8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#FFEAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF0D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient1);
export default __webpack_public_path__ + "static/media/gradient1.8a1f4d8ec4cba7937292e07c0f100c58.svg";
export { ForwardRef as ReactComponent };